import axios from "axios";
import * as error from "./error";
const http = axios.create();
http.defaults.baseURL = "https://adx.teleads.ai";
http.interceptors.request.use((config) => {
    return config;
});
http.interceptors.response.use((res) => {
    if (res.data.status == 200) {
        return res.data;
    }
    else {
        for (const key in error) {
            if (res.data.code == error[key].code) {
                error[key](res.data);
            }
        }
        return res.data.message;
    }
});
export { http };
export default http;
//# sourceMappingURL=request.js.map